module.exports = __webpack_public_path__ + "static/media/inactivar-activar.e6ea2f04.svg";